import React from 'react';
import { Tag } from '@flexisaf/flexibull2';
import PropTypes from 'prop-types';
import Theme from 'utils/theme';

const TAGS = {
  VALID: { label: 'Valid NIN', color: Theme.PrimaryGreen },
  INVALID: { label: 'Invalid NIN', color: Theme.PrimaryRed },
  FAILED: { label: 'Verification failed', color: Theme.PrimaryGrey },
};

const NimcStatusTag = ({ status, title }) => {
  const tag = TAGS[status?.status || status];
  if (!tag) return null;
  return (
    <span title={title || status?.message || 'Verified via NIMC'} style={{ display: 'inline-flex' }}>
      <Tag color={tag.color} solid fontColor="#fff" height={18} font={9} pad="0 6px">
        {tag.label}
      </Tag>
    </span>
  );
};

NimcStatusTag.propTypes = {
  status: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  title: PropTypes.string,
};

export default NimcStatusTag;
